module.exports = __webpack_public_path__ + "static/media/magnifying_glass.b85fd7bd.svg";